import dayjs from 'dayjs';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as _ from 'lodash';
import { getDueDateDiffInDays, isBefore } from '../../../../utils/dateUtlis';
const duration = require('dayjs/plugin/duration');

dayjs.extend(duration);

class DateBoxContainer extends Component {
  static propTypes = {
    locale: PropTypes.string,
    dueDate: PropTypes.any
  };

  static defaultProps = {
    dueDate: dayjs()
  };

  /**
   * @description render deadLine Calendar icon
   * @memberof DateBoxContainer
   */
  renderCalendar(actualMoment, selectedDeadLine, isUpperThanDay, dueDate) {
    const isDueDateLowerThanNow = isBefore(dueDate, dayjs());
    return (
      <div>
        <div className="sc-assignment-date-box-month">{actualMoment.format('MMM')}</div>
        <div className="sc-assignment-date-box-body">
          <div className="sc-assignment-date-box-day-name">{actualMoment.format('ddd')}</div>
          <div>{isUpperThanDay || isDueDateLowerThanNow ? dueDate.date() : this.getCalendarText(dueDate)}</div>
        </div>
      </div>
    );
  }

  /**
   * @description Returns the assignment date string
   * @param {Object} dueDate Object with value and timeUnit properties
   * @returns {String}
   * @memberof DateBoxContainer
   */
  getCalendarText = dueDate => {
    const deadLine = {};
    const dueDateDiff = dueDate.diff(dayjs()) - 1000;

    let hours = Math.round(dayjs.duration(dueDateDiff, 'milliseconds').asHours());

    if (hours) {
      deadLine.timeUnit = 'h';
      deadLine.value = hours;
    } else {
      let minutes = Math.round(dayjs.duration(dueDateDiff, 'milliseconds').asMinutes());
      deadLine.timeUnit = 'm';
      deadLine.value = minutes;
    }
    return `+${deadLine.value}${deadLine.timeUnit}`;
  };

  /**
   * @description render component function
   * @memberof DateBoxContainer
   */
  render() {
    const { dueDate: rawDueDate, locale } = this.props;
    const dueDate = rawDueDate ?? dayjs();

    if (!_.isEmpty(locale)) {
      dayjs.locale(locale); /* sets the localization */
    }

    const actualMoment = dayjs();
    let isUpperThanDay = getDueDateDiffInDays(dueDate);
    const isDueDateLowerThanStartDate = isBefore(dayjs(dueDate), dayjs());

    return (
      <div
        className={`sc-assignment-date-box ${
          !isUpperThanDay && !isDueDateLowerThanStartDate ? 'option-labeled-box' : ''
        }`}
      >
        <div className="calendar-top-lines">
          <span className="calendar-top-line" />
          <span className="calendar-top-line" />
          <span className="calendar-top-line" />
        </div>
        {this.renderCalendar(actualMoment, {}, isUpperThanDay, dueDate)}
      </div>
    );
  }
}

export default DateBoxContainer;

DateBoxContainer.defaultProps = {
  dueDate: dayjs()
};
